import { render } from "./ResultTable.vue?vue&type=template&id=5f0dfe2d&scoped=true"
import script from "./ResultTable.vue?vue&type=script&lang=js"
export * from "./ResultTable.vue?vue&type=script&lang=js"

import "./ResultTable.vue?vue&type=style&index=0&id=5f0dfe2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0dfe2d"]])

export default __exports__